// eslint-disable-next-line unicorn/text-encoding-identifier-case -- used for document.characterSet, not for readFile
export const UTF_CHARACTER_SET = 'UTF-8';
